var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "142 377 134.1 139.8",
    enableBackground: "new 142 377 134.1 139.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209,442.5c-18.1,0-32.8-14.7-32.8-32.8S191,377,209,377s32.8,14.7,32.8,32.8S227.1,442.5,209,442.5z M209,390 c-10.9,0-19.8,8.9-19.8,19.8s8.9,19.8,19.8,19.8s19.8-8.9,19.8-19.8S219.9,390,209,390z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.2,516.8c-7.9,0-22-1.4-27.8-10.8c-2.4-3.8-4.2-10.4,0.6-20.1c12.3-25,33.1-37.1,63.5-37.1c29.3,0,50.2,11.9,63.7,36.3 c4.6,8.3,5.2,15.4,1.8,21.2c-5.5,9.4-19.5,10.4-25.3,10.4c-0.6,0-1,0-1.2,0h-73.3C173.8,516.8,173.1,516.8,172.2,516.8z  M208.5,461.8c-25.3,0-41.8,9.5-51.8,29.8c-1,2-2.4,5.6-1.2,7.5c1.7,2.7,8.6,4.6,16.8,4.6c0.8,0,1.4,0,1.4,0l0.3,0l73.8,0 c0,0,0.3,0,0.8,0c6.8,0,12.7-1.7,14.1-4c0.9-1.5,0.2-4.5-1.9-8.3C249.6,471.2,233,461.8,208.5,461.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.163d185c.svg";
export { ForwardRef as ReactComponent };